import { useRef, useState } from 'react';
import { allChartTypeManifests } from '../charts/factory';
import { TpChartManifest } from '../charts/interfaces';
import useResizeObserver from '../hooks/resize-observer';

import styles from './ChartTypesDocumentation.module.scss';
import { BlockingOpenedItem } from '../../../components/blocking-opened-item/BlockingOpenedItem';
import ChartTypeDetailed from './ChartTypeDocumentationDetails';

function renderChartTypeInOverview(chartType: TpChartManifest, openChart: () => void): any {
  return (
    <div key={chartType.id} className={styles.overviewChartType} onClick={openChart}>
      <div className={styles.overviewChartTypeTitle}>{chartType.name}</div>
      {chartType.examples &&
        chartType.examples.map((example) => (
          <div key={example.id} style={{ position: 'relative' }}>
            <img src={`/chartsamples/${example.id}.png`} className={styles.overviewExampleThumbnail} />
            <div className={styles.thumbnailGloss} />
          </div>
        ))}
    </div>
  );
}

function ChartTypesOverview() {
  const refOverviewClientArea = useRef<HTMLDivElement>(null);

  const [colCount, setColCount] = useState(5);
  const [openedChartType, setOpenedChartType] = useState<TpChartManifest | null>(null);

  useResizeObserver(refOverviewClientArea, (info: any) => {
    if (!refOverviewClientArea.current) return;
    setColCount(Math.max(1, Math.round(refOverviewClientArea.current.clientWidth / 250)));
  });

  const columns: any = [];
  for (let colNr = 0; colNr < colCount; colNr++)
    columns.push({
      estimHeight: 0,
      elements: [],
    });

  for (const chartType of allChartTypeManifests) {
    let bestCol = columns[0];
    for (const col of columns) if (col.estimHeight < bestCol.estimHeight) bestCol = col;
    bestCol.elements.push(renderChartTypeInOverview(chartType, () => setOpenedChartType(chartType)));
    bestCol.estimHeight += 10;
    if (chartType.examples) bestCol.estimHeight += chartType.examples.length * 100;
  }

  return (
    <div className={styles.overviewScrollContainer}>
      <div className={styles.overviewContainer} ref={refOverviewClientArea}>
        {columns.map((col: any, idx: number) => (
          <div className={styles.overviewColumn} key={`idx_${idx}`} style={{ width: `${100 / colCount}%` }}>
            {col.elements}
          </div>
        ))}

        {openedChartType && (
          <BlockingOpenedItem
            fraction={80}
            close={() => {
              setOpenedChartType(null);
            }}
          >
            <ChartTypeDetailed chartType={openedChartType} />
          </BlockingOpenedItem>
        )}
      </div>
    </div>
  );
}

export default ChartTypesOverview;
